import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const PreprintIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6835 13.3995C9.9369 14.1461 8.72644 14.1461 7.97986 13.3995L5.93207 11.3518C5.18548 10.6052 5.18549 9.39471 5.93207 8.64813L7.97986 6.60034C8.72644 5.85376 9.9369 5.85376 10.6835 6.60034C11.4301 7.34693 11.4301 8.55738 10.6835 9.30397L9.98751 9.99994L10.6835 10.6959C11.4301 11.4425 11.4301 12.653 10.6835 13.3995Z"
        fill="var(--cdl-chart-red-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.37407 5.99458C8.45522 4.91343 10.2081 4.91343 11.2893 5.99458C12.3704 7.07574 12.3704 8.82864 11.2893 9.9098L10.6835 9.304L11.2893 9.9098L11.1991 9.99998L11.2893 10.0902C12.3704 11.1713 12.3704 12.9242 11.2893 14.0054C10.2081 15.0865 8.45522 15.0865 7.37406 14.0054L5.32628 11.9576C4.24512 10.8764 4.24512 9.12353 5.32628 8.04237L7.37407 5.99458ZM10.0777 7.20617C9.66568 6.79416 8.99767 6.79416 8.58566 7.20617L6.53787 9.25396C6.12585 9.66597 6.12585 10.334 6.53787 10.746L5.93425 11.3496L6.53787 10.746L8.58566 12.7938C8.99767 13.2058 9.66568 13.2058 10.0777 12.7938C10.4897 12.3818 10.4897 11.7138 10.0777 11.3017L10.6835 10.696L10.0777 11.3017L9.38171 10.6058C9.04714 10.2712 9.04715 9.72875 9.38172 9.39418L10.0777 8.69821C10.4897 8.28619 10.4897 7.61819 10.0777 7.20617Z"
        fill="var(--cdl-chart-red-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.73373 5.84445L12.3278 2.25041C13.0749 1.50328 14.2862 1.50328 15.0334 2.25041C15.7805 2.99754 15.7805 4.20889 15.0334 4.95602L11.4829 8.50648L8.73373 5.84445Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.722 1.64453C12.8037 0.562826 14.5575 0.562826 15.6392 1.64453C16.7209 2.72623 16.7209 4.48002 15.6392 5.56172L12.0887 9.11218C11.7579 9.44295 11.223 9.44726 10.887 9.12186L8.13778 6.45983C7.97283 6.30011 7.87889 6.08086 7.87704 5.85126C7.87519 5.62166 7.96558 5.40092 8.12794 5.23857L11.722 1.64453L12.3278 2.25032L11.722 1.64453ZM14.4276 2.85612C14.015 2.44356 13.3461 2.44356 12.9336 2.85612L9.95516 5.83453L11.4732 7.30448L14.4276 4.35013C14.8401 3.93757 14.8401 3.26868 14.4276 2.85612L15.0334 2.25032L14.4276 2.85612Z"
        fill="currentColor"
      />
      <path
        d="M7.66433 17.7496C6.9172 18.4967 5.70586 18.4967 4.95873 17.7496C4.21159 17.0025 4.21159 15.7911 4.95873 15.044L10.0027 10L4.95873 4.95602C4.21159 4.20888 4.21159 2.99754 4.95873 2.25041C5.70586 1.50328 6.9172 1.50328 7.66433 2.25041L14.0611 8.6472C14.0623 8.6484 14.0635 8.6496 14.0647 8.65081C14.8082 9.39823 14.8071 10.6069 14.0611 11.3528L7.66433 17.7496Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.35293 1.64453C5.43464 0.562828 7.18842 0.562824 8.27013 1.64453L14.6669 8.04131L14.6721 8.0465C15.7486 9.12865 15.7469 10.8785 14.6669 11.9585L8.27013 18.3553C7.18842 19.437 5.43464 19.437 4.35293 18.3553C3.27123 17.2736 3.27123 15.5198 4.35293 14.4381L8.79112 9.99993L4.35293 5.56172C3.27123 4.48002 3.27123 2.72623 4.35293 1.64453ZM7.05854 2.85612C6.64598 2.44356 5.97709 2.44356 5.56452 2.85612C5.15196 3.26868 5.15196 3.93757 5.56452 4.35014L10.6085 9.39414C10.9431 9.72871 10.9431 10.2712 10.6085 10.6057L5.56452 15.6497C5.15196 16.0623 5.15196 16.7312 5.56452 17.1437C5.97708 17.5563 6.64598 17.5563 7.05854 17.1437L13.4553 10.7469C13.8672 10.335 13.8679 9.66762 13.4573 9.25494L13.4553 9.2529L13.4547 9.2523L7.05854 2.85612Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.036 17.752C14.2924 18.4957 13.0529 18.4619 12.2677 17.6767L6.00747 11.4165C5.2222 10.6312 5.18847 9.39177 5.93212 8.64811C6.67578 7.90446 7.31568 7.28406 7.31568 7.28406L14.9607 14.9836C15.7459 15.7689 15.7797 17.0084 15.036 17.752Z"
        fill="var(--cdl-chart-red-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.71932 6.669C7.05617 6.34241 7.59304 6.34752 7.92362 6.68046L15.5665 14.3779C15.5669 14.3783 15.5673 14.3787 15.5677 14.3791C16.6549 15.4676 16.7503 17.2494 15.6418 18.3578C14.5329 19.4667 12.7502 19.3708 11.6619 18.2825L5.40167 12.0223C4.31333 10.934 4.21744 9.15124 5.32632 8.04235C5.70065 7.66802 6.04861 7.32497 6.30289 7.07559C6.43009 6.95085 6.53397 6.84941 6.60615 6.77907L6.68963 6.69783L6.71932 6.669ZM7.30692 8.49121C7.0849 8.70975 6.81878 8.97307 6.53791 9.25394C6.15948 9.63237 6.13106 10.3285 6.61326 10.8107L12.8734 17.0709C13.3556 17.5531 14.0518 17.5247 14.4302 17.1462C14.8086 16.7678 14.8371 16.0717 14.3549 15.5895L14.3527 15.5873L7.30692 8.49121Z"
        fill="var(--cdl-chart-red-base)"
      />
    </svg>
  );
};

export default PreprintIcon;
